<template>
    <div class="password-setting-panel">
        <h2 class="panel-title">Update your password</h2>
        <div class="password-setting-wrapper">
            <rt-input
              class="password-input"
              ref="currPassword"
              editType="password"
              placeholder="Current Password"
              floatingLabel="Current Password"
              autocomplete="off"
              v-model="currPassword"
            />
            <rt-input
              class="password-input"
              ref="newPassword"
              type="password"
              placeholder="New Password"
              floatingLabel="New Password"
              autocomplete="off"
              v-model="newPassword"
            />
            <rt-input
                class="password-input"
				ref="confirmPassword"
                type="password"
                placeholder="Confirm New Password"
                floatingLabel="Confirm New Password"
                autocomplete="off"
                v-model="confirmPassword"
            />
            <p class="submit-error" v-if="errorMessage">{{ errorMessage }}</p>
        </div>
        <div class="setting-panel-footer">
          <primary-button class="btn-close" @click="$emit('close')">Close</primary-button>
          <primary-button class="btn-save" @click="handleUpdatePassword">Update Password</primary-button>
        </div>
    </div>
</template>

<script>
import RtInput from '../Input.vue';
import PrimaryButton from '../PrimaryButton.vue';
import { validatePassword } from '../../signup/validators';
import { getUser } from 'common/UserService';
import Toast from 'common/Toast';
import { updatePassword } from 'common/api';
export default {
  components: {
    RtInput,
    PrimaryButton
  },
  data() {
    return {
      submitting: false,
      currPassword: '',
      newPassword: '',
      confirmPassword: '',
      errorMessage: ''
    }
  },
  methods: {
	validatePasswords() {
	  let isValid = true;

	  if (isValid && this.currPassword) {
		isValid = validatePassword(this.currPassword);
		if (isValid !== true) {
		  this.$refs.currPassword.focus();
		  this.$refs.currPassword.$el.classList.add('error');
		} else {
		  this.$refs.currPassword.$el.classList.remove('error');
		}
	  } else {
		this.$refs.currPassword.$el.classList.remove('error');
	  }

	  if (isValid === true && this.newPassword) {
		isValid = validatePassword(this.newPassword);
		if (isValid !== true) {
		  this.$refs.newPassword.focus();
		  this.$refs.newPassword.$el.classList.add('error');
		} else {
		  this.$refs.newPassword.$el.classList.remove('error');
		}
	  } else {
		this.$refs.newPassword.$el.classList.remove('error');
	  }

	  if (isValid === true && this.confirmPassword) {
		isValid = validatePassword(this.confirmPassword);
		if (isValid !== true) {
		  this.$refs.confirmPassword.focus();
		  this.$refs.confirmPassword.$el.classList.add('error');
		} else {
		  this.$refs.confirmPassword.$el.classList.remove('error');
		}
	  } else {
		this.$refs.confirmPassword.$el.classList.remove('error');
	  }

	  if (isValid === true) {
		this.$refs.currPassword.focus();
		this.$refs.currPassword.$el.classList.add('error');
	  }
	},
    async handleUpdatePassword() {
      if (this.submitting) return;
      this.errorMessage = ''
      if (!this.currPassword) {
        this.$refs.currPassword.focus();
		this.$refs.currPassword.$el.classList.add('error');
		this.errorMessage = 'Current password is required';
        return
      }
      if (!this.newPassword) {
        this.$refs.newPassword.focus();
		this.$refs.newPassword.$el.classList.add('error');
		this.errorMessage = 'New password is required';
        return
      }
      if (!this.confirmPassword || this.confirmPassword !== this.newPassword) {
        if (!this.confirmPassword) {
          this.errorMessage = 'You have not confirmed your new password';
        } else {
          this.errorMessage = 'New and Confirm passwords are not matched';
        }
		this.$refs.confirmPassword.focus();
		this.$refs.currPassword.$el.classList.remove('error');
		this.$refs.newPassword.$el.classList.remove('error');
		this.$refs.confirmPassword.$el.classList.add('error');
      } else {
        this.submitting = true;
        const user = getUser();
        const result = await updatePassword(user.userId, this.currPassword, this.newPassword, this.confirmPassword);
        if (result.success) {
          Toast.success(result.message);
        } else {
          Toast.error(result.message);
		  this.validatePasswords();
        }
        this.submitting = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../variables';
.password-setting-panel {
  .panel-title {
    font-family: $title-font;
    font-size: 18px;
  }
  .password-setting-wrapper {
    margin-top: 16px;
    .password-input {
      margin-bottom: 8px;
    }
    .submit-error {
      font-size: 12px;
      color: $light-red;
    }
  }
}
</style>


